/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordDateTimeFieldComponent } from '../../admin/form/form-record/fields/datetime/form-record-date-time-field.component';
/* eslint-enable */

export class FormRecordDateTimeFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordDateTimeFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
